import React, {useState} from "react";
import Button from '@mui/material/Button';
import TextCard from "../../../../../../../components/TextComps/TextCard";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import { TextLip } from "./TextLip";
import { SourcesLip } from "./SourcesLip";

export default function Lip() {

const [open, setOpen] = useState(false);
const handleOpen = () => {setOpen(true);};
const handleClose = () => {setOpen(false);};

return(
<>      

<Button onClick={handleOpen} variant="text" sx={{textTransform: 'none'}} >
           <TextCard 
            textcard={'Lipidemia' }
           />
</Button>

<CustomDialog open={open} onClose={handleClose}

        title='Lipidemia - Variants'

        content={<TextLip />}

        sources={<SourcesLip />}

/>

</>
)}